import React from "react";
import img_1 from "../../../assets/images/home/serviceImage_1.png";
import img_2 from "../../../assets/images/home/serviceImage_2.png";
import img_3 from "../../../assets/images/home/serviceImage_3.png";
import img_4 from "../../../assets/images/home/serviceImage_4.png";
import img_5 from "../../../assets/images/home/serviceImage_5.png";

import CustomerSupport from '../../../assets/images/icons-new/customer-support.png'
import QualityGuaranteed from '../../../assets/images/icons-new/quality-guaranteed.png'
import QuickShipping from '../../../assets/images/icons-new/quick-shipping.png'
import SecuredPayment from '../../../assets/images/icons-new/secured-payments.png'

function serviceBlock(props) {
  const { block } = props;
  return (
    <>
      <div id="serviceBlock">
        {/* <div
          className={`text-center row m-0 bg-gradient py-sm-5 py-4 ${(block && block === 2 && "d-none") || "d-block"
            }`}
        >
          <h1 className="text-light col-sm-12 col-11 mx-auto p-0 py-1">
            Get exclusive access to new products, deals &amp; surprise treats.
          </h1>
          <div className="input-group col-sm-4 col-11 mx-auto px-sm-4 px-0">
            <input
              type="text"
              className="form-control"
              placeholder="Enter your email to subscribe to our newsletters."
              aria-label="Enter your email to subscribe to our newsletters."
              aria-describedby="button-addon2"
            />
            <div className="input-group-append">
              <button
                className="btn btn-outline-light text-primary-color font-weight-bolder"
                type="button"
                id="button-addon2"
              >
                Subscribe
              </button>
            </div>
          </div>
          <p className="text-light col-11 mx-auto mt-3 mb-sm-0">
            You are signing up to receive product updates and newsletters.
          </p>
          <p className="text-light col-11 mx-auto mt-sm-0 mt-2">
            By signing up, you are consenting to our privacy policy but you can
            opt out at any time.
          </p>
        </div> */}
        <div
          className={`row m-0 justify-content-center py-3 ${(block && block === 1 && "d-none") || ""
            }`}
          id="subserviceBlock"
          style={{ backgroundColor: '#EEEAE6' }}
        >
          <div className="col-sm-2 col-6 d-sm-flex align-items-sm-center text-center text-sm-left card_b">
            <img src={QuickShipping} className="d-block mx-auto mx-sm-0 py-3 pr-3 home-icons" alt="" />
            <span className="d-block text-grey-79 fs-15 fw-500">
              {/* Free Shipping &amp;
              <br />
              Easy Returns */}
              Quick Shipping
            </span>
          </div>
          <div className="col-sm-2 col-6 d-sm-flex align-items-sm-center text-center text-sm-left card_b">
            <img src={SecuredPayment} className="d-block mx-auto mx-sm-0 py-3 pr-3 home-icons" alt="" />
            <span className="d-block text-grey-79 fs-15 fw-500">
              {/* Safe Shopping &amp; <br />
              Secured Payments */}
              Secured Payments
            </span>
          </div>
          {/* <div className="col-sm-2 col-6 d-sm-flex align-items-sm-center text-center text-sm-left card_b">
            <img src={img_5} className="d-block mx-auto mx-sm-0 py-3 pr-3 home-icons" alt="" />
            <span className="d-block text-grey-79 fs-14">
              Mad Deals from the <br />
              House of Vb Dace!
            </span>
          </div> */}
          <div className="col-sm-2 col-6 d-sm-flex align-items-sm-center text-center text-sm-left card_b">
            <img src={QualityGuaranteed} className="d-block mx-auto mx-sm-0 py-3 pr-3 home-icons" alt="" />
            <span className="d-block text-grey-79 fs-15 fw-500">
              {/* Customer Support
              <br />
              b/n 9 AM to 6 PM */}
              Quality Guaranteed
            </span>
          </div>

          <div className="col-sm-3 col-6 d-sm-flex align-items-sm-center card_b text-center">

            <a href="mailto:support@vbdace.com?body=Hi,How%20May%20I%20Help%20You" target="_top" style={{ cursor: 'pointer', textDecoration: 'none' }}>
              <img src={CustomerSupport} className="d-block mx-auto mx-sm-0 py-3 pr-3 home-icons" alt="" />
            </a>
            <a href="mailto:support@vbdace.com?body=Hi,Venkatesh%20Bhatt" target="_top" style={{ cursor: 'pointer', textDecoration: 'none' }}>
              <span className="d-block text-grey-79 fs-15">
                Customer Support <br/>b/n 10 am to 6 pm
              </span>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export const ServiceBlock = serviceBlock;
